import { render, staticRenderFns } from "./add_note.vue?vue&type=template&id=c9bfbd58&scoped=true"
import script from "./add_note.vue?vue&type=script&lang=js"
export * from "./add_note.vue?vue&type=script&lang=js"
import style0 from "./add_note.vue?vue&type=style&index=0&id=c9bfbd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bfbd58",
  null
  
)

export default component.exports